module.exports = __webpack_public_path__ + "img/netflow-config.be97eca4.png";